import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { baseGrid } from '@helpers/grid';
import { imageCoverContainer } from '@helpers/image';
import { Device, from, until } from '@helpers/media';
import { contentStyles, h4 } from '@helpers/typography';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
const Container = styled.section `
  --widgetBgColor: ${brand.white};
  overflow: hidden;
  position: relative;
  display: block;
  background-color: var(--widgetBgColor);

  &[data-background-theme='lightgrey'] {
    --widgetBgColor: ${brand.secondary.lightGrey};
  }

  &[data-background-theme='green'] {
    --widgetBgColor: ${brand.secondary.green};
  }

  ${SectionWrapperStyles.Container} {
    --sectionSpacing: ${fluid(17, 100)};
  }
`;
const Grid = styled.div `
  ${baseGrid};
  align-items: center;
  position: relative;
  z-index: 2;

  @media ${until(Device.Tablet)} {
    row-gap: 32px;
  }
`;
const ContentArea = styled.div `
  --textColor: ${brand.base.blue};
  position: relative;
  grid-column: span 24;
  grid-row: 2;
  color: var(--textColor);

  [data-background-theme='green'] & {
    --textColor: ${brand.white};
  }

  @media ${from(Device.Tablet)} {
    grid-column: span 10;
    grid-row: 1;
  }

  [data-media-alignment='left'] & {
    @media ${from(Device.Tablet)} {
      grid-column: 15 / span 10;
    }
  }
`;
const Title = styled.h2 `
  ${h4};
  position: relative;
`;
const Intro = styled.div `
  ${contentStyles};

  p {
    font-size: ${fluid(18, 20)};
    line-height: ${fluid(28, 30)};
  }

  max-width: 700px;
  padding-bottom: 25px;
`;
const Ctas = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;
const MediaArea = styled.div `
  grid-column: span 24;
  grid-row: 1;
  display: grid;

  @media ${from(Device.Tablet)} {
    grid-column: 12 / span 13;
    justify-content: end;
  }

  [data-media-alignment='left'] & {
    @media ${from(Device.Tablet)} {
      grid-column: span 13;
    }
  }
`;
const MediaHolder = styled.div `
  aspect-ratio: 960 / 622;
  position: relative;
  border-radius: 10000px 0 0 10000px;
  padding-top: 20px;
  overflow: visible;

  @media ${until(Device.Tablet)} {
    padding-top: 10px;
  }

  [data-media-alignment='left'] & {
    border-radius: 0 10000px 10000px 0;
    padding-top: 0;
    padding-bottom: 30px;

    @media ${until(Device.Tablet)} {
      padding-bottom: 10px;
    }
  }
`;
const Image = styled.img `
  ${imageCoverContainer()};
  border-radius: 10000px 0 0 10000px;
  position: relative;

  [data-media-alignment='left'] & {
    border-radius: 0 10000px 10000px 0;
  }
`;
const ShapeShadow = styled.div `
  --shadowColor: ${brand.primary.blue};
  position: absolute;
  background-color: var(--shadowColor);
  transform: translate(0, -20px);
  width: 100%;
  height: 100%;
  border-radius: 10000px 0 0 10000px;

  [data-shadow-theme='blue'] & {
    --shadowColor: ${brand.primary.blue};
  }

  [data-shadow-theme='orange'] & {
    --shadowColor: ${brand.primary.orange};
  }

  [data-shadow-theme='green'] & {
    --shadowColor: ${brand.secondary.green};
  }

  @media ${until(Device.Tablet)} {
    transform: translate(0, -10px);
  }

  [data-media-alignment='left'] & {
    transform: translate(0, 0);
    border-radius: 0 10000px 10000px 0;

    @media ${until(Device.Tablet)} {
      transform: translate(0, 0);
    }

    @media ${from(Device.Tablet)} {
      border-radius: 0 10000px 10000px 0;
    }
  }
`;
const SplitContentStyles = {
    Container,
    ContentArea,
    Grid,
    Image,
    Intro,
    Ctas,
    MediaArea,
    MediaHolder,
    ShapeShadow,
    Title,
};
export default SplitContentStyles;
